import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Response } from '@angular/http';

import { Effect, Actions, toPayload } from '@ngrx/effects';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../reducers';

import { ShoppingCart, Order } from '../../models';
import { OauthHelper, OrderApi, PrinterApi, ShoppingCartApi } from '../../services/webservice'

import { MessageActions, AppActions } from '../../actions';
import { ShoppingCartTicketGroupDTO } from "../../services/webservice"
import { ErrorHandlerService } from '../../services/index'
import { CheckoutActions } from './checkout.actions'
import { ShoppingCartActions } from '../shopping-cart/shopping-cart.actions'
import { DocumentDisplayService } from '../documents/document-display.service'
import { UnsafeAction } from "../../actions/UnsafeAction"

import { WindowOpenService } from "../../services/index";

/* tslint:disable */
@Injectable()
export class CheckoutEffect {

	private deliveryURL = '/api/deliveries/v1';

	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private checkoutActions: CheckoutActions,
		private messageActions: MessageActions,
		private shoppingCartActions: ShoppingCartActions,
		private orderApi: OrderApi,
		private errorHandler: ErrorHandlerService,
		private route: ActivatedRoute,
		private router: Router,
		private documentDisplayService: DocumentDisplayService,
		private printerApi: PrinterApi,
		private shoppingCartApi: ShoppingCartApi,
		private oauthHelper: OauthHelper,
		private windowOpenService: WindowOpenService
	) { }

	@Effect() placeOrder$ = this.updates$
		.ofType(CheckoutActions.PLACE_ORDER)
		.flatMap((action: UnsafeAction) => this.orderApi.createOrder(action.payload))
		.map(order => this.checkoutActions.orderPlaced(order))

	@Effect() orderPlaced$ = this.updates$
		.ofType(CheckoutActions.ORDER_PLACED)
		.do(action => this.router.navigate(["/checkout/completePayment"]))
		.map(action => this.shoppingCartActions.getMyShoppingCart())

	@Effect() completePayment$ = this.updates$
		.ofType(CheckoutActions.COMPLETE_PAYMENT)
		.flatMap((action: UnsafeAction) => this.orderApi.confirmePayment(action.payload))
		.withLatestFrom(this.store)
		.do(([order, store]: [Order, AppState]) => this.saleRouting(store.keepAppointment))
		.map(([order, store]: [Order, AppState]) => this.checkoutActions.orderPaid(order))


	@Effect() delayPayment$ = this.updates$
		.ofType(CheckoutActions.DELAY_PAYMENT)
		.withLatestFrom(this.store)
		.do(([action, store]: [UnsafeAction, AppState]) => this.saleRouting(store.keepAppointment))
		.ignoreElements()

	@Effect() startLoadPrintable$ = this.updates$
		.ofType(CheckoutActions.ORDER_PAID)
		.withLatestFrom(this.store)
		.filter(([action,store]: [UnsafeAction, AppState]) => action.payload.shipmentType === "CARRY" && store.checkout.documentsToPrint.ticketPrint)
		.map(([action,store]: [UnsafeAction, AppState]) => this.checkoutActions.loadTickets(action.payload.secureOrderId))

	@Effect() loadDocuments$ = this.updates$
        .ofType(CheckoutActions.ORDER_PAID)
        .filter((action: UnsafeAction) => action.payload.shipmentType === "CARRY") // Die Checkboxen werden später im document-display.service geprüft
		.map((action: UnsafeAction) => this.checkoutActions.displayDocuments(action.payload.uuid))

	@Effect() loadTicketStatus$ = this.updates$
		.ofType(CheckoutActions.LOAD_TICKETS)
		.delay(1000)
		.flatMap((action: UnsafeAction) => {
			return this.orderApi.getDeliveryStatus(action.payload)
				.do(status => console.log("STATUS:: ", status))
				.map(status => {
					if (status.status === "NOT_READY") {
						return this.checkoutActions.loadTickets(action.payload)
					}
					if (status.status === "ERROR") {
						return this.messageActions.displayMessage("Beim verarbeiten der Bestellung ist ein unerwarteter Fehler aufgetreten. Bitte melden Sie sich im leoticket support.", "error")
					}
					return this.checkoutActions.printTickets(status)
				})
		})

	@Effect() printTIckets$ = this.updates$
		.ofType(CheckoutActions.PRINT_TICKETS)
		.do((action: UnsafeAction) => console.log("PRINTING TICKETS: ", action.payload))
		.withLatestFrom(this.store)
		.map(([action, store]: [UnsafeAction, AppState]) => {
			const pdfTickets = store.checkout.documentsToPrint.pdfTickets
			if (!pdfTickets) {
				const tktHrefs = Object.keys(action.payload.ticketRefs).map(key => action.payload.ticketRefs[key].href);
				return this.printerApi.printTickets(tktHrefs, store.checkout.ticketPrinterId)
			} else {
				Object.keys(action.payload.pdfDownloadRefs)
					.map(key => action.payload.pdfDownloadRefs[key].href)
					.map(href => {
						this.windowOpenService.windowOpen(href + "?access_token=" + this.oauthHelper.getAccessToken(), '_blank')
					})
				return Observable.of(Promise.resolve());
			}
		})
		.do(obs$ => obs$.subscribe(() => console.log('PRINTING FINISHED')))
		.ignoreElements()


		//FIXME: wir brauchen hier die orderSecureId um Anschreiben aufrufen zu können.
	@Effect() displayDocuments$ = this.updates$
		.ofType(CheckoutActions.DISPLAY_DOCUMENTS)
		.withLatestFrom(this.store)
		.delay(2000) // We need to wait a little for the server to generate the pdf otherwise we will get a 404 Page opened
		.do(([action, store]: [UnsafeAction, AppState]) => this.documentDisplayService.displayDocuments(action.payload,null, store.checkout.documentsToPrint))
		.ignoreElements()


		@Effect() loadAvailableShipmentTypes$ = this.updates$
		.ofType(CheckoutActions.LOAD_AVAILABLE_SHIPMENTTYPES)
		.flatMap((action: UnsafeAction) => this.shoppingCartApi.getAvailableShipmentTypes(action.payload)
			.map(availableShipmentTypesDto => this.checkoutActions.loadAvailableShipmentTypesSuccess(availableShipmentTypesDto)))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))


		private handleError(error: Response, defaultMessage: string): Observable<Action> {
			const errorMessage = this.errorHandler.getErrorMessage(error, defaultMessage);
			return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
		}


		saleRouting(keepAppointmentStore) {
			if(keepAppointmentStore.eventStorageId) {
				if (keepAppointmentStore.userSetHasVisualQuota) {
					// quota is marked with seatingplan
					return this.router.navigate(['/seatingplanSale', keepAppointmentStore.eventStorageId])
				} else {
					// quota is marked without seatingplan
					return this.router.navigate(['/sale', keepAppointmentStore.eventStorageId], { relativeTo: this.route })
				}
			} else {
				return this.router.navigate(["/sale"])
			}
		}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout.effect.ts